export default function(el, binding, vnode) {
  if (uniqueness(binding)) {
    return
  }

  // 过滤一下可用参数
  let args
  const field = ['category', 'action', 'opt_label', 'opt_value']
  if (typeof binding.value === 'object') {
    const obj = binding.value
    args = field.map(key => {
      return obj[key]
    })
    args = args.filter(item => item !== undefined)
  }

  el.addEventListener(
    'click',
    () => {
      console.log(args)
      if (process.env.NODE_ENV === 'production') {
        window._hmt.push(['_trackEvent', ...args])
      }
    },
    false
  )
}

function uniqueness(binding) {
  if (binding.oldValue !== undefined) {
    return true
  } else {
    return false
  }
}

